/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Download_Web_DescInputs */

const en_cad_download_web_desc = /** @type {(inputs: Cad_Download_Web_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No install. Runs in your browser via WebAssembly`)
};

/**
* | output |
* | --- |
* | "No install. Runs in your browser via WebAssembly" |
*
* @param {Cad_Download_Web_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_download_web_desc = /** @type {((inputs?: Cad_Download_Web_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Download_Web_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_download_web_desc(inputs)
});
export { cad_download_web_desc as "cad.download.web_desc" }